interface HeroProps {
  imageSrc: string;
  imageAltText: string;
  title: string;
}

export default function HeroImage(props: HeroProps) {
  return (
    <div className="relative h-screen">
      <div className="absolute inset-0 -z-10">
        <img
          src={props.imageSrc}
          alt={props.imageAltText}
          loading="lazy"
          className="h-full w-full object-contain object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary " />
      </div>

      <div className="pt-48 flex justify-center items-center">
        <h1 className="text-4xl font-bold text-white">{props.title}</h1>
      </div>
    </div>
  );
}
